import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AnimatedHeartHero from "./AnimatedHeartHero";

const HeroCarouselSection = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const image = "/bella&bestia.webp";

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center items-center overflow-hidden py-10 px-4">
      {/* CSS Animation for mobile panning */}
      <style>
        {`
          @keyframes pan-horizontal {
            0% { object-position: 40% center; }
            50% { object-position: 80% center; }
            100% { object-position: 40% center; }
          }
          
          .animate-pan-horizontal {
            animation: pan-horizontal 10s ease-in-out infinite;
          }
        `}
      </style>

      {/* Carousel Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 w-full h-full" 
             style={{ filter: 'grayscale(1)' }}>
          <img
            src={image}
            alt={t("heroTitle")}
            className={`w-full h-full object-cover ${isMobile ? 'animate-pan-horizontal' : ''}`}
            style={{ 
              objectPosition: isMobile ? '50% center' : 'center center'
            }}
          />
        </div>
      </div>

      {/* Grouped Content with Animation */}
      <div className="absolute flex flex-col items-start justify-start z-20 text-left 
        top-0 left-[3%]
        sm:top-[0.5%] sm:left-[2.5%]
        md:top-[0.5%] md:left-[1.5%]
        lg:top-[0.5%] lg:left-[-1%]
        xl:top-[0.5%] xl:left-[-2%]
        2xl:top-[0.5%] 2xl:left-[-3%]
        w-[70vw] h-[40vh] 
        sm:w-[65vw] sm:h-[40vh]
        md:w-[60vw] md:h-[40vh]
        lg:w-[60vw] lg:h-[45vh]
        xl:w-[65vw] xl:h-[50vh]
        2xl:w-[70vw] 2xl:h-[55vh]">
        <div className="relative flex flex-col items-start w-full h-full p-0 opacity-80" style={{ transform: 'rotate(-15deg)' }}>
          {/* Animation */}
          <div className="w-full h-full">
            <div className="w-full h-full">
              <AnimatedHeartHero />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroCarouselSection;